import { render, staticRenderFns } from "./personalCommissionDetail.vue?vue&type=template&id=5e85f9ed"
import script from "./personalCommissionDetail.vue?vue&type=script&lang=js"
export * from "./personalCommissionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports